import prettier from 'prettier/standalone';
import typescript from 'prettier/parser-typescript';
import SyntaxHighlighter from 'react-syntax-highlighter';

import { atomOneDark } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import React from 'react';
import { Segment } from './Segment';
import styled from '@emotion/styled';
import { Header } from 'semantic-ui-react';
import { Card } from './Card';

interface CodeProps {
	value: string;
}

const Highlighter = styled(SyntaxHighlighter)`
	border: 2px solid #f2711c;
	border-radius: 5px;
`;

export const Code: React.FC<CodeProps> = ({ value }) => (
	<Segment basic>
		<Card marginy="t">
			<Header as="h2">&hellip; if you call this code:</Header>
			<Highlighter language="javascript" style={atomOneDark}>
				{prettier
					.format(value, {
						parser: 'typescript',
						plugins: [typescript],
						printWidth: 50
					})
					.replace(/[\r\n]+$/, '')}
			</Highlighter>
		</Card>
	</Segment>
);
